import { QueryClient } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { useAuth } from '~/auth/AuthProvider'
import LoginPage from '~/auth/LoginPage'
import SuperadminGate from '~/auth/SuperadminGate'
import { TRPCProvider } from '~/utils/trpc'
import { routeTree } from './routeTree.gen'

const router = createRouter({
  routeTree,
  context: {
    session: undefined!,
    queryClient: undefined!
  }
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

type AppProps = {
  queryClient: QueryClient
}

const App = ({ queryClient }: AppProps) => {
  const { session } = useAuth()

  if (!session) {
    return <LoginPage />
  }

  return (
    <SuperadminGate>
      <TRPCProvider queryClient={queryClient}>
        <RouterProvider router={router} context={{ session, queryClient }} />
      </TRPCProvider>
    </SuperadminGate>
  )
}

export default App
